import React from 'react';
import CompareShell, { AppStoreBadges, InstitutionalTrustBar } from './compare/CompareShell';

const InvitePage: React.FC = () => {
  return (
    <CompareShell>
      {/* HERO SECTION WITH ATMOSPHERIC AMBIENT MESH */}
      <section className="relative overflow-hidden pt-8 sm:pt-14 pb-14 sm:pb-20 px-4 sm:px-6">
        {/* Soft Ambient Radial Lights (Faithful to Landing Page public-hero-mesh) */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[500px] w-full max-w-5xl rounded-full bg-[radial-gradient(circle_at_50%_20%,rgba(13,148,136,0.12),rgba(98,199,255,0.06)_40%,transparent_70%)] blur-3xl -z-10"
        />

        <div className="relative mx-auto max-w-2xl rounded-[32px] sm:rounded-[40px] bg-white/95 backdrop-blur-2xl p-8 sm:p-12 shadow-[0_28px_80px_-16px_rgba(15,23,42,0.10),0_1px_2px_rgba(15,23,42,0.04)] border border-slate-200/80 ring-1 ring-white/60 text-center space-y-6">
          {/* Clero Icon Hero */}
          <img
            src="/clero_icon.png"
            alt="Clero"
            className="mx-auto h-20 w-20 rounded-2xl shadow-md ring-4 ring-slate-100/90 object-cover"
          />

          {/* Heading & Subtitle */}
          <div className="space-y-3">
            <h1 className="text-3xl sm:text-5xl font-black tracking-tight text-slate-950 leading-tight">
              A friend invited you to join them on <span className="text-teal-600">Clero</span>.
            </h1>
            <p className="mx-auto max-w-lg text-base sm:text-lg text-slate-600 font-medium leading-relaxed">
              Download the app to view your invite, track shared purchases and groups, and settle debts directly from bank to bank with $0 fees.
            </p>
          </div>

          {/* Download App Badges */}
          <div className="pt-2 flex items-center justify-center">
            <AppStoreBadges badgeHeightClass="h-10 sm:h-11" />
          </div>
        </div>
      </section>

      {/* INSTITUTIONAL BANKING INFRASTRUCTURE & SECURITY METRICS BAR */}
      <InstitutionalTrustBar />

      {/* THREE PILLARS FEATURE BREAKDOWN */}
      <section className="py-8 px-4 sm:px-6">
        <div className="mx-auto max-w-5xl rounded-3xl bg-white p-8 sm:p-12 space-y-8">
          <div className="border-b border-slate-100 pb-6 text-center sm:text-left">
            <h2 className="text-2xl sm:text-3xl font-black text-slate-950 tracking-tight">
              Group expenses with direct bank settlement
            </h2>
            <p className="mt-2 text-base text-slate-600 font-medium leading-relaxed">
              Everything you need to manage shared household bills, vacation spending, and everyday tabs without IOU chasing.
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-3">
            <div className="space-y-2.5">
              <h3 className="text-base font-bold text-slate-950">1. Instant itemized receipt scanning</h3>
              <p className="text-sm text-slate-600 leading-relaxed font-medium">
                Snap photos of restaurant and grocery receipts. Clero itemizes every item with AI and splits tax and tip to the exact cent.
              </p>
            </div>

            <div className="space-y-2.5">
              <h3 className="text-base font-bold text-slate-950">2. Dedicated roommate & trip groups</h3>
              <p className="text-sm text-slate-600 leading-relaxed font-medium">
                Organize shared life into Monthly groups that auto-settle on the 1st, Trip groups that close on return dates, or On-Demand tabs.
              </p>
            </div>

            <div className="space-y-2.5">
              <h3 className="text-base font-bold text-slate-950">3. Same-day direct bank deposits*</h3>
              <p className="text-sm text-slate-600 leading-relaxed font-medium">
                Funds move directly between checking accounts on the same day* with $0 fees. Never pay 1.75% instant transfer fees again.
              </p>
            </div>
          </div>
        </div>
      </section>
    </CompareShell>
  );
};

export default InvitePage;
